@if (tableauService.addTableauRequest$ | async) {
}

@if (!!data.requests?.length) {
  <div>
    <span class="fw-bold">Current Pending Requests</span>
    @if (!data.error) {
      @for (tblRequest of data.requests; track tblRequest) {
        <div>
          {{tblRequest.Access}} (submitted {{tblRequest.Created.TimeStamp | date: 'MMM d, y'}})
        </div>
      }
    }
    @if (data.error) {
      <p>There was a problem retrieving your requests.</p>
      <p>If the problem persists, please contact the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk&#64;kenan-flagler.unc.edu</a>.</p>
    }
  </div>
}
<br />
<div>
  <span class="fw-bold">Submit a new request:</span>

  <fieldset>
    @if (dashboards$ | async; as dashboards) {
      <div id='scrollable-dropdown' class="form-group dropdown">
        <label for="tableauType" class="me-2">Dashboard:</label>
        <select id="tableauType" [(ngModel)]="model.dashboard">
          @for (dashboard of dashboards; track dashboard) {
            <option [ngValue]="dashboard">{{dashboard}}</option>
          }
        </select>
      </div>
    }

    <div class="form-group mt-3">
      <label for="tableauMessage">Justification for Access: </label>
      <textarea id="tableauMessage" type="text" class="form-control"
        placeholder="Justification is required."
      maxlength="2000" [(ngModel)]="model.message"></textarea>
    </div>

    <div class="form-check mt-3">
      <input type="checkbox" class="form-check-input" id="tableauAgree" [(ngModel)]="model.agree" />
      <label class="form-check-label" for="tableauAgree">
        I@if (profileService.profile$ | async; as profile) {
        <span>, {{profile.biodata.displayName}},</span>
      }
      confirm that I have read and agree to the
      <a href="{{data.tableauAttestationUrl}}" target="_blank">terms and requirements</a>
      for use and disclosure of Sensitive Information related to Tableau dashboard access.
    </label>
  </div>
  <br />

  <button class="btn btn-sm btn-primary me-2"
    [disabled]="!(!!model.message && !!model.dashboard && !!model.agree)"
    (click)="addTableauRequest()">
    Send
  </button>
  <span class="fw-bold">{{tableauService.tableauMessage}}</span>
</fieldset>
</div>
